import {Component, Input, OnInit, OnDestroy, EventEmitter} from '@angular/core';

import {GlobalState} from '../../../global.state';

import { TranslateService } from '@ngx-translate/core';

import { AuthService } from '../../../services/auth.service';
import { PagesComponent } from '../../../pages/pages.component';
import { Subscription } from 'rxjs';
import { BaMenuService } from '../../services';
import { Router } from '@angular/router';
import { Ng2DeviceService } from 'ng2-device-detector';
import { ConfigurationService } from '../../../services/configuration.service';
import { NotificationService } from '../../../services/notification.service';

@Component({
    selector: 'app-ba-page-top',
    templateUrl: './baPageTop.component.html',
    styleUrls: ['./baPageTop.component.scss']
})
export class BaPageTopComponent implements OnInit, OnDestroy {
    @Input() ImgPerfile: string;
    public isScrolled: boolean;
    public isMenuCollapsed: boolean;
    public currentLang: string;
    public langs = {
        es: 'Español',
        en: 'English'
    };
    protected _onRouteChange: Subscription;

    showDrp: boolean;
    username: string;
    company_name: string;
    role: string;
    user_acronym: string;
    notifications: number;
    deviceInfo = null;
    chrome_version = '56.0.2924';
    safari_version = '10.0.3';
    explorer_version = '10.0';
    firefox_version = '45.7.0esr';

    adminStr: string = 'admin';
    userStr: string = 'user';
    freelancerStr: string = 'freelancer';
    allStr: string = 'all';
    postcontractingStr: string = 'postcontracting';

    premium: string;
    user_search: string;
    company_status:  number;
    noBrowserSupported:  string;
    browser_version:  string;

    errorConnection:  boolean;

    event: EventEmitter<String> = new EventEmitter<String>();

    isIn = false;   // store state
    toggleState() { // click handler
        const bool = this.isIn;
        this.isIn = bool === false ? true : false;
    }

    constructor(
        private _state: GlobalState,
        public loginService: AuthService,
        private translate: TranslateService,
        public pagesComponent: PagesComponent,
        private _service: BaMenuService,
        private _router: Router,
        private deviceService: Ng2DeviceService,
        private configurationService: ConfigurationService,
        private notificationService: NotificationService,
            ) {
        this.showDrp = false;
        this.isScrolled = false;
        this.isMenuCollapsed = false;
        this.currentLang = this.translate.currentLang;
        this._state.subscribe('menu.isCollapsed', (isCollapsed) => {
        this.isMenuCollapsed = isCollapsed;
        this.preconf();
    });
    }


    public checkRole() {
      if (((this.role == this.adminStr || this.role == this.userStr || this.role == this.freelancerStr || this.role == this.allStr)
        && (this.role !== this.postcontractingStr)
        && (this.role !== 'docchecker'))) {
          return true;
      }else {
          return false;
      }
    }

    public checkRole2() {
      if ((this.role == this.adminStr || this.role == this.userStr || this.role == this.freelancerStr || this.role == this.allStr) && (this.role !== this.postcontractingStr)) {
        return true;
      }else{
        return false;
      }
    }

    public checkRole3() {
      if (this.role !== this.postcontractingStr){
        return true;
      }else{
        return false;
      }
    }

    public preconf() {
        this.deviceInfo = this.deviceService.getDeviceInfo();
        if (this.deviceInfo.browser === 'chrome') {
        this.browser_version = this.chrome_version;
        } else if (this.deviceInfo.browser === 'safari') {
        this.browser_version = this.safari_version;
        } else if (this.deviceInfo.browser === 'ie') {
        this.browser_version = this.explorer_version;
        } else if (this.deviceInfo.browser === 'firefox') {
        this.browser_version = this.firefox_version;
        } else {
        this.browser_version = '';
        }

        if (this.browser_version !== '') {
        const options = {lexicographical: true, zeroExtend: true};
        const compare = this.versionCompare(this.deviceInfo.browser_version, this.browser_version, options);
        if (compare < 0) {
            this.noBrowserSupported = 'true';
        } else {
            this.noBrowserSupported = 'false';
        }
        } else {
        this.noBrowserSupported = 'true';
        }

        this.configurationService.configuration$.subscribe(
        response => {
            if (response) {
            this.refreshConfiguration();
            } else {
            this.company_status = -1;
            }
            // this.dialog.open(MessageBoxDialog,
            // {data: {message: "No se pudo conectar con el servidor, Problemas de conexión con internet", success:true, showIcon:true}});
        }
        );

        this.configurationService.errorHttp$.subscribe(
        response => {
            if (response) {
            this.errorConnection = true;
            } else {
            this.errorConnection = false;
            }
            // this.dialog.open(MessageBoxDialog,
            // {data: {message: "No se pudo conectar con el servidor, Problemas de conexión con internet", success:true, showIcon:true}});
        }
        );
        this.refreshConfiguration();
    }

    public ngOnInit(): void {
      if (localStorage.getItem('role')) {
        this.role = localStorage.getItem('role');
      } else {
        this.role = '';
      }
        this._onRouteChange = this._router.events.subscribe((event) => {
            console.log('settings');
            this.selectMenuAndNotify();
        });
    }

    public ngOnDestroy(): void {
        this._onRouteChange.unsubscribe();
    }

    public settings () {
        console.log('settings');
        // event.preventDefault();
    }

    public selectMenuAndNotify(): void {
        console.log('account');
        this._state.notifyDataChanged('menu.activeLink', 'account');
    }

    public logout() {
        event.preventDefault();
        this.loginService.logout();
        this._router.navigate(['login']);
    }

    // provine for switch language
    public changeLanguage() {
        event.preventDefault();
        const lang = (this.pagesComponent.currentLang === 'en') ? 'es' : 'en';
        this.pagesComponent.changeLanguage(lang);
    }

    // provine for languageService
    public languageChaged(lang) {
        this.currentLang = lang;
    }

    public toggleMenu() {
        this.isMenuCollapsed = !this.isMenuCollapsed;
        this._state.notifyDataChanged('menu.isCollapsed', this.isMenuCollapsed);
        return false;
    }

    public scrolledChanged(isScrolled) {
        this.isScrolled = isScrolled;
    }

    refreshConfiguration() {
        if (localStorage.getItem('name') ) {
          this.username = localStorage.getItem('name');
          this.user_acronym = localStorage.getItem('name').substr(0, 1);
        } else {
          this.username = '';
          this.user_acronym = '';
        }

        if (localStorage.getItem('status') ) {
          this.company_status = Number(localStorage.getItem('status'));
        } else {
          this.company_status = -1;
        }

        if (localStorage.getItem('premium')) {
          this.premium = localStorage.getItem('premium');
        } else {
          this.premium = '0';
        }

        if (localStorage.getItem('user_search')) {
          this.user_search = localStorage.getItem('user_search');
        } else {
          this.user_search = '0';
        }

        if (localStorage.getItem('role')) {
          this.role = localStorage.getItem('role');
        } else {
          this.role = '';
        }
    }

    /**
     * Compares two software version numbers (e.g. "1.7.1" or "1.2b").
     *
     * This function was born in http://stackoverflow.com/a/6832721.
     *
     * @param {string} v1 The first version to be compared.
     * @param {string} v2 The second version to be compared.
     * @param {object} [options] Optional flags that affect comparison behavior:
     * <ul>
     *     <li>
     *         <tt>lexicographical: true</tt> compares each part of the version strings lexicographically instead of
     *         naturally; this allows suffixes such as "b" or "dev" but will cause "1.10" to be considered smaller than
     *         "1.2".
     *     </li>
     *     <li>
     *         <tt>zeroExtend: true</tt> changes the result if one version string has less parts than the other. In
     *         this case the shorter string will be padded with "zero" parts instead of being considered smaller.
     *     </li>
     * </ul>
     * @returns {number|NaN}
     * <ul>
     *    <li>0 if the versions are equal</li>
     *    <li>a negative integer iff v1 < v2</li>
     *    <li>a positive integer iff v1 > v2</li>
     *    <li>NaN if either version string is in the wrong format</li>
     * </ul>
     *
     * @copyright by Jon Papaioannou (["john", "papaioannou"].join(".") + "@gmail.com")
     * @license This function is in the public domain. Do what you want with it, no strings attached.
     */
    versionCompare(v1, v2, options) {
        const lexicographical = options && options.lexicographical;
        const zeroExtend = options && options.zeroExtend;
        let v1parts = v1.split('.');
        let v2parts = v2.split('.');

        function isValidPart(x) {
            return (lexicographical ? /^\d+[A-Za-z]*$/ : /^\d+$/).test(x);
        }

        if (!v1parts.every(isValidPart) || !v2parts.every(isValidPart)) {
            return NaN;
        }

        if (zeroExtend) {
            while (v1parts.length < v2parts.length) {
                v1parts.push('0');
            }
            while (v2parts.length < v1parts.length) {
                v2parts.push('0');
            }
        }

        if (!lexicographical) {
            v1parts = v1parts.map(Number);
            v2parts = v2parts.map(Number);
        }

        for (let i = 0; i < v1parts.length; ++i) {
            if (v2parts.length === i) {
            return 1;
            }

            if (Number(v1parts[i]) === Number(v2parts[i])) {
                continue;
            } else if (Number(v1parts[i]) > Number(v2parts[i])) {
                return 1;
            } else {
                return -1;
            }
        }

        if (v1parts.length !== v2parts.length) {
            return -1;
        }
        return 0;
    }
}



// WEBPACK FOOTER //
// /var/www/_deploy/front-company-testing/2018-09-30-21-57-10/src/app/theme/components/baPageTop/baPageTop.component.ts